import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "d-flex w-100" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = { class: "ml-1" }
const _hoisted_4 = { class: "d-flex flex-wrap" }

import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import {__} from "~/ts/library/Translate";
import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {computed} from "vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import MultiContactDialogHistory
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/multiContacts/MultiContactDialogHistory.vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";


import {ref} from 'vue';

let clientMultiContactsCollapsed = ref(false);

const __default__ = {
    name: "SideMenuClientMultiContacts"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let allClientsDialog = ref<{
    visible: boolean,
    clients: OperatorApplicationApi.OperatorApplicationClientOpenApiModel[]
}>();

let emits = __emit;

function getIntegrationPlatform(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    if (client.integration) {
        return OperatorAccountStore.integrationPlatformDictionary.value[client.integration.platformId];
    }
    return null;
}

function onClick(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    emits("click", client);
}

let clients = computed<OperatorApplicationApi.OperatorApplicationClientOpenApiModel[]>(() => {
    return [props.userdata, ...props.userdata.multiContacts.items].sort((a, b) => {
        return a.id > b.id ? -1 : 1;
    }) as OperatorApplicationApi.OperatorApplicationClientOpenApiModel[];
});

function openAllChats() {
    allClientsDialog.value = {
        visible: true,
        clients: clients.value
    };
}

function onOpenFromHistory(username: string) {
    allClientsDialog.value = null;
    OperatorApplicationBuddyList.openClientByUsername(username);
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (!__props.site.isFree && __props.userdata.multiContacts.items.length)
    ? (_openBlock(), _createBlock(SideMenuCard, {
        key: 0,
        class: "info",
        collapsed: _unref(clientMultiContactsCollapsed),
        "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => (_isRef(clientMultiContactsCollapsed) ? (clientMultiContactsCollapsed).value = $event : clientMultiContactsCollapsed = $event))
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)('Мульти-контакты')), 1),
            _createElementVNode("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                link: "",
                class: "pt-0 pb-0 h-auto"
              }, {
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, { icon: "comments" })
                ]),
                _: 1
              })), [
                [_directive_my_tooltip, _unref(__)('Все чаты')],
                [
                  _directive_on_native,
                  openAllChats,
                  "click",
                  { stop: true }
                ]
              ])
            ]),
            (_unref(allClientsDialog) && _unref(allClientsDialog).visible)
              ? (_openBlock(), _createBlock(_component_el_dialog, {
                  key: 0,
                  class: "overflow right full-height-body hide-header",
                  "body-class": "p-0 pb-1",
                  modelValue: _unref(allClientsDialog).visible,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(allClientsDialog).visible) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(MultiContactDialogHistory, {
                      class: "h-100",
                      userdata: __props.userdata,
                      clients: _unref(allClientsDialog).clients,
                      onOpen: onOpenFromHistory
                    }, null, 8, ["userdata", "clients"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clients), (client) => {
              return _withDirectives((_openBlock(), _createBlock(CoreUiChatClientAvatar, {
                key: client.id,
                client: client,
                "always-online": "",
                "integration-platform": getIntegrationPlatform(client),
                class: _normalizeClass({'avatar': true, selected: client.id === __props.userdata.id})
              }, null, 8, ["client", "integration-platform", "class"])), [
                [_directive_my_tooltip, `#${client.id} - ${client.displayDescr}`],
                [_directive_on_native, () => _unref(emits)('click', client), "click"]
              ])
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["collapsed"]))
    : _createCommentVNode("", true)
}
}

})